import { Stack, Box, Link, Flex } from "@chakra-ui/react";
import { HeaderLink } from "./HeaderLink";
import EarnDropDown from "./EarnDropDown";
import EcosystemDropDown from "./EcosystemDropDown";

const getLinks = (isCollapse, inDrawer) => {
  return [
    {
      isInternalLink: true,
      isButton: false,
      content: "Trade",
      to: "/trade",
      isTradeEarn: true,
    },
    {
      isInternalLink: false,
      isButton: true,
      content: <EarnDropDown isCollapse={isCollapse} inDrawer={inDrawer} />,
      to: "/",
      isTradeEarn: true,
    },
    // {
    //   isInternalLink: true,
    //   isButton: false,
    //   content: "Referrals",
    //   to: "/referrals",
    // },
    {
      isInternalLink: true,
      isButton: false,
      content: "Rewards",
      to: "/rewards",
    },
    {
      isInternalLink: false,
      isButton: true,
      content: (
        <EcosystemDropDown isCollapse={isCollapse} inDrawer={inDrawer} />
      ),
      to: "/",
    },
  ];
};

export const AppHeaderLinks = ({ showAll, ...props }) => {
  const list = getLinks(true).filter((item) => showAll || item.isTradeEarn);

  return (
    <Stack {...props} direction={"row"} spacing={"16px"} alignItems={"center"}>
      {list.map((link, id) => {
        return (
          <Box
            key={id}
            color="gray.light"
            fontSize={"14px"}
            letterSpacing="-0.02em"
          >
            {link.isInternalLink ? (
              <HeaderLink
                key={id}
                to={link.to}
                px={"8px"}
                h={"32px"}
                borderRadius={"20px"}
                color={"gray.light"}
                _hover={{
                  background: "gray.sombre",
                  color: "brand",
                }}
              >
                {link.content}
              </HeaderLink>
            ) : link.isButton ? (
              link.content
            ) : (
              <Link
                isExternal
                href={link.to}
                textDecoration={"none"}
                _hover={{ textDecoration: "none" }}
              >
                {link.content}
              </Link>
            )}
          </Box>
        );
      })}
    </Stack>
  );
};

export const AppDrawerLinks = ({ showAll, ...props }) => {
  const list = getLinks(true, true).filter(
    (item) => showAll || !item.isTradeEarn
  );

  return (
    <Stack {...props}>
      {list.map((link, id) => {
        return (
          <Flex
            key={id}
            color="gray.light"
            fontSize={"14px"}
            w={"full"}
            letterSpacing="-0.02em"
            alignItems={"center"}
          >
            {link.isInternalLink ? (
              <HeaderLink
                key={id}
                to={link.to}
                w={"full"}
                px={"24px"}
                h={"48px"}
              >
                {link.content}
              </HeaderLink>
            ) : link.isButton ? (
              link.content
            ) : (
              <Link
                isExternal
                href={link.to}
                w={"full"}
                textDecoration={"none"}
                _hover={{ textDecoration: "none" }}
              >
                {link.content}
              </Link>
            )}
          </Flex>
        );
      })}
    </Stack>
  );
};
